const AUTOMATIC_CONNECT_NOT_PRESENT = -1;
const AUTOMATIC_CONNECT_FALSE = 0;
const AUTOMATIC_CONNECT_TRUE = 1;

export default {
  AUTOMATIC_CONNECT_NOT_PRESENT,
  AUTOMATIC_CONNECT_FALSE,
  AUTOMATIC_CONNECT_TRUE
};
